/**
 * 超管首页「近期动态」API client（运营主管设计 T4 / D10）。
 *
 * 仅超管（advisor:manage）能调：近 7 天新增销售账号 / 客户转交 / 新增合伙人。
 * 每一块独立降级：读失败时该块是空数组，且 partial 里对应的标记为 true。
 * 响应里没有手机号 / 微信号 / unionId / 客户称呼，客户只用数量表达。
 */
import { apiClient } from './client';

interface ServiceResponse<T> {
  code: number;
  message: string;
  data: T;
  requestId: string;
}

export interface OversightSalesAccountDto {
  id: string;
  nickname: string;
  status: string;
  createdBy: { id: string; nickname: string | null } | null;
  /** 毫秒时间戳 */
  createdAt: number;
}

export interface OversightTransferDto {
  actor: { id: string; nickname: string | null; role: string | null };
  to: { id: string; nickname: string | null };
  customerCount: number;
  /** 这一组最近一次转交的时间（毫秒） */
  lastAt: number;
  reasons: string[];
  /** 操作者非超管且任意 24 小时内转交 ≥ 25 位 */
  flagged: boolean;
}

export interface OversightPartnerDto {
  id: string;
  name: string;
  city: string | null;
  status: 'pending_bind' | 'active' | 'stopped';
  createdAt: number;
}

export interface OversightDto {
  windowStart: number;
  windowEnd: number;
  newSalesAccounts: OversightSalesAccountDto[];
  transfers: OversightTransferDto[];
  newPartners: OversightPartnerDto[];
  partial: { newSalesAccounts: boolean; transfers: boolean; newPartners: boolean };
}

export async function getOversight() {
  const resp = await apiClient.get<ServiceResponse<OversightDto>>('/advisor/oversight');
  return resp.data.data;
}
